import { Box, Typography, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface RankingCardProps {
  position?: number;
  /** Prompt #3 — percentual de formuladoras atrás do usuário */
  percentileAhead?: number;
  /** Prompt #3 — fórmulas restantes para atingir o próximo tier */
  formulasToNextTier?: number;
  /** Prompt #3 — rótulo do próximo tier (ex.: "TOP 10") */
  nextTierLabel?: string;
}

export default function RankingCard({ position, percentileAhead, formulasToNextTier, nextTierLabel }: RankingCardProps) {
  const theme = useTheme();
  if (!position || position < 1) return null;

  const bars = [
    { label: position > 1 ? `${position - 1}º` : null, height: 48, highlight: false },
    { label: `${position}º`, height: 78, highlight: true },
    { label: `${position + 1}º`, height: 38, highlight: false },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "18px",
        p: "24px 26px",
      }}
    >
      <Typography component="h3" sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: 22, color: "text.primary" }}>
        Ranking ProAtivos
      </Typography>
      <Typography sx={{ m: "4px 0 18px", fontSize: "12.5px", color: "text.secondary" }}>
        Sua posição entre as formuladoras
      </Typography>

      <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, height: 110 }}>
        {bars.map((bar, index) =>
          bar.label === null ? (
            <Box key={index} sx={{ flex: 1 }} />
          ) : (
            <Box key={index} sx={{ flex: 1, textAlign: "center", position: "relative" }}>
              {bar.highlight && (
                <Typography sx={{ mb: "4px", fontSize: "13px", fontWeight: 700, color: "primary.main" }}>
                  Você
                </Typography>
              )}
              <Box
                sx={{
                  height: bar.height,
                  borderRadius: "8px 8px 0 0",
                  backgroundColor: bar.highlight ? "primary.main" : theme.palette.brand.cream,
                }}
              />
              <Typography
                sx={{
                  mt: "6px",
                  fontSize: "11px",
                  fontWeight: bar.highlight ? 600 : 400,
                  color: bar.highlight ? "text.primary" : "text.secondary",
                }}
              >
                {bar.label}
              </Typography>
            </Box>
          )
        )}
      </Box>

      {percentileAhead != null && (
        <Box
          sx={{
            mt: 2,
            p: 1.5,
            borderRadius: "12px",
            backgroundColor: theme.palette.brand.cream,
          }}
        >
          <Typography sx={{ fontSize: "12px", color: "text.secondary", lineHeight: 1.5 }}>
            Você está à frente de <strong>{percentileAhead}%</strong> das formuladoras.
            {formulasToNextTier != null && (
              <>{" "}Faltam <strong>{formulasToNextTier}</strong> {formulasToNextTier === 1 ? "fórmula" : "fórmulas"} para o <strong>{nextTierLabel ?? "TOP 10"}</strong>.</>
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
